import {useCallback, useState} from 'react';
import {Add, Close, Edit, Save} from '@mui/icons-material';
import {IconButton, Stack, TextField, Typography} from '@mui/material';
import SubmitButton from '../../styles/buttons/SubmitButton';

const NameUpdateAliasShow = ({
  name,
  url,
  onSuccess,
  payloadKey,
  isEditAllowed,
}: {
  name: string;
  url: string;
  onSuccess: (val: string) => void;
  payloadKey: string;
  isEditAllowed: boolean;
}) => {
  const [label, setLabel] = useState(name);
  const [isEdit, setIsEdit] = useState(false);

  const handleEdit = useCallback(() => {
    setLabel(name);
    setIsEdit(true);
  }, [name]);

  const handleClose = useCallback(() => {
    setIsEdit(false);
  }, []);

  const successAction = useCallback(() => {
    onSuccess(label);
    handleClose();
  }, [handleClose, label, onSuccess]);

  if (isEdit) {
    return (
      <Stack direction='row' alignItems='center' spacing={1} sx={{flex: 1}}>
        <TextField
          value={label}
          inputProps={{'aria-label': 'Name'}}
          onChange={e => setLabel(e.target.value)}
          className='w-300'
        />
        <SubmitButton
          url={url}
          payload={{[payloadKey]: label}}
          title='Submit'
          icon={<Save />}
          buttonProps={{
            disabled: label.trim() === name.trim(),
            color: 'success',
          }}
          successAction={successAction}
        />
        <IconButton onClick={handleClose} title='Cancel' color='error'>
          <Close />
        </IconButton>
      </Stack>
    );
  }
  return (
    <Stack direction='row' alignItems='center' spacing={2}>
      <Typography title={name} className='ellipsis max-w-380'>
        {name}
      </Typography>
      {isEditAllowed && (
        <IconButton
          onClick={handleEdit}
          aria-label={name ? 'Edit name alias' : 'Add name alias'}>
          {name ? <Edit /> : <Add />}
        </IconButton>
      )}
    </Stack>
  );
};

export default NameUpdateAliasShow;
